<template>
  <div class="playerList">
    <div class="Navbar">
    <section class="hero is-white is-fullwidth" style="text-align:start">
      <div class="hero-body" style="border-bottom: medium solid #4a4a4a;">
        <div class="container">
          <h1 class="title">対戦・ランキング</h1>
          <h2 class="subtitle">対戦相手を選ぼう！</h2>
        </div>
      </div>
    </section>
    </div>

    <section class="hero is-white">
      <div class="columns">
        <div class="column is-1"></div>
        <div class="column is-10">
          <h1>検索</h1>
          <input
            class="input"
            type="text"
            placeholder="検索したいタイトルを入力してください"
            v-model="filterName"
            v-on:keyup="serach"
          />
          <br />
          <br />

            <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
            <div v-for="item of items" :key="item">
              <Node :title="item.title" :id="item.id" :code="item.code" :rank="item.ranking"></Node>
              <br />
            </div>

        </div>
        <div class="column is-1"></div>
      </div>
    </section>
  </div>
</template>
<script>
const apiUrl =
  process.env.VUE_APP_DB_API;
const config = {
  headers: {
    "Content-Type": "application/json"
  }
};
import axios from "axios";
import Node from "./PlayerList/PlayerListNode";
export default {
  name: "PlayerList",
  data() {
    return {
      postLog: "",
      filterName: "",
      items: [],
      s_items: [],
      isLoading: false
    };
  },
  components: {
    Node
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.initialize(); // 初期化処理
      next();
    });
  },

  methods: {
    getData() {},
    serach() {
      if (this.filterName == "") {
        this.items = this.s_items;
      } else {
        this.items = this.s_items.filter(
          item => item.name.indexOf(this.filterName, 0) != -1
        );
      }
      this.items.sort((a, b) => a.ranking - b.ranking);
    },

    initialize() {
      this.$axios
        .get(apiUrl)
        .then(response => {
          this.s_items = response.data;
          this.items = response.data;
          this.ip = response;
          this.isLoading = false;
          this.items.sort((a, b) => a.ranking - b.ranking);
        })
        .catch(reason => {});
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
box {
  margin-top: 10px;
}
h1 {
  margin-top: 20px;
  font-size: 30px;
  text-align: left;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
